import { useLayoutEffect, type CSSProperties } from 'react'
import { useRouteError } from 'react-router-dom'

import { isLikelyChunkOrDeployLoadError, reloadForNewDeployment } from '@/lib/deploy-chunk-recovery'

const mainStyle: CSSProperties = {
	padding: 24,
	fontFamily:
		'"Gotham", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
	textAlign: 'center',
}

/**
 * React Router errorElement for the root — catches lazy / render errors that
 * still surface as route errors after a deploy. Plain HTML only (no MUI — this
 * tree renders outside ThemeProvider).
 */
export function DeployChunkRouteErrorElement() {
	const error = useRouteError()

	useLayoutEffect(() => {
		if (isLikelyChunkOrDeployLoadError(error)) {
			// Overlay + reload lives in deploy-chunk-recovery (plain DOM); avoid a second message here.
			reloadForNewDeployment()
		}
	}, [error])

	if (isLikelyChunkOrDeployLoadError(error)) {
		return null
	}

	const message =
		error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unexpected error'

	return (
		<main style={{ ...mainStyle, textAlign: 'left' }}>
			<pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{message}</pre>
		</main>
	)
}
